export const ITEM_URL: string = "item";
export const SUB_CATEGORY_URL: string = "subcategory";
export const CATEGORY_URL: string = "category";
export const MENU_CARD_URL: string = "menu-card";
export const ALLGERNS_URL: string = "allergens";
export const SEARCH_URL: string = "search";
export const SEARCH_PARAM: string = "search";
export const ALL_ITMES_PARAM: string = "allItems";
export const LIVE_PARAM: string = "live";
export const TOKEN_PARAM: string = "token";
export const TABLE_PARAM: string = "table";
export const EXPIRED_PARAM: string = "expired";
export const SESSION_ID_PARAM: string = "sessionId";
export const SESSION_TIMEOUT_WARNING: number = Number.parseInt(process.env.REACT_APP_SESSION_TIMEOUT_WARNING_MINUTES ?? '5');
export const HOMEPAGE = process.env.PUBLIC_URL;
export const TARGET_ORIGIN_URL = process.env.REACT_APP_TARGET_ORIGIN_URL ?? '';